import Login from '~/pages/login';
import Logout from '~/pages/logout';
import TokenExtractor from '~/pages/AAA-users';
import ForgotPassword from '~/pages/forgot-password';
import Activation from '~/pages/activation';
import Home from '~/pages/home';
import ChangePassword from '~/pages/change-password';
import Authorization from '~/pages/authorization';
import AuthResponse from '~/pages/auth-response';
import DeviceAuthentication from '~/pages/device-authentication';
import Terms from '~/pages/terms-of-use';

const routes = [{
  path: '/home',
  component: Home,
  label: 'Home',
  icon: 'home',
  main: true,
  private: true,
}, {
  path: '/terms-of-use',
  component: Terms,
}, {
  path: '/user/change-password',
  component: ChangePassword,
  private: true,
}, {
  path: '/forgot-password',
  component: ForgotPassword,
}, {
  path: '/activations/:id',
  component: Activation,
}, {
  path: '/login/:organization',
  component: Login,
}, {
  path: '/login',
  component: Login,
}, {
  path: '/set-session',
  component: TokenExtractor,
}, {
  path: '/authorization',
  component: Authorization,
}, {
  path: '/device-authentication',
  component: DeviceAuthentication,
}, {
  path: '/logout',
  component: Logout,
  private: true,
}, {
  path: '/auth-response',
  component: AuthResponse,
}];

/* eslint-disable-next-line */
export { routes };
